import LoadingSvg from "../../../assets/loading.svg";

export default function LoadingState({
  maxHeight,
  maxWidth,
}: {
  maxHeight: string | number | undefined;
  maxWidth: string | number | undefined;
}) {
  return (
    <img
      src={LoadingSvg}
      style={{ maxHeight: maxHeight, maxWidth: maxWidth }}
      alt="Vazio"
    />
  );
}
